import { render, staticRenderFns } from "./pc.vue?vue&type=template&id=58a536c8&scoped=true"
import script from "./pc.vue?vue&type=script&lang=js"
export * from "./pc.vue?vue&type=script&lang=js"
import style0 from "./pc.vue?vue&type=style&index=0&id=58a536c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a536c8",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/footer/footer/pc.vue
// module id = null
// module chunks = 